import KPI from "@/views/modules/kpi/Kpi.vue";
import KPIDirections from "@/views/modules/kpi/KpiDirections/KpiDirections.vue";

export default {
  path: "/kpi",
  name: "kpi",
  component: KPI,
  meta: {
    auth: true
  },
  redirect: {
    name: "kpi-directions"
  },
  children: [
    {
      path: "directions",
      name: "kpi-directions",
      component: KPIDirections,
      meta: {
        auth: true,
        searchable: true,
        title: "KPI Gerencial",
        index: true
      }
    }
  ]
};
